import React from "react";
import {Col, Container, Row} from "react-bootstrap";
import UserDashboardPageUserMenu from "../@@Parts/@Menu";
import {UserDashboardPageContent, UserDashboardPageContentSection} from "@Pages/@@UserPages/@Dashboard/@@Parts";
import UserDashboardConnectedAppsSummarySection from "@Pages/@@UserPages/@Dashboard/@Apps/AppsSummary";
import UserDashboardConnectedEmailProvidersSection from "@Pages/@@UserPages/@Dashboard/@Apps/EmailProviders";

import "./index.scss";

import GmailLogo from "./@Icons/gmail_logo.svg";
import OutlookLogo from "./@Icons/logo-outlook.svg";
import PaypallLogo from "./@Icons/logo-paypal.svg";
import ButtonBank from "./@Icons/button-bank.svg";
import IconSettingsS from "./@Icons/icon-settings-s-grey.svg";
import IconDisconnectS from "./@Icons/icon-disconnect-s-grey.svg";
import IconRemoveS from "./@Icons/icon-remove-s-grey.svg";
import IconClockS from "./@Icons/icon-clock-s-grey.svg";
import IconNotesS from "./@Icons/icon-notes-s-grey.svg";
import IconFilePresentS from "./@Icons/icon-file_present-s-grey.svg";

import {SvgIconComponent} from "@Components/Elements";
import ButtonComputer from "@Pages/@@UserPages/@Dashboard/@Security/@Icons/button-computer.svg";
import BadgeElementComponent from "@Components/@Elements/@Badges";
import {ButtonComponent} from "@Components/Forms";
import {DashboardStateCardElementComponent} from "@Components/@Elements/@Cards";
import DividerElementComponent from "@Components/@Elements/@Dividers";


export const UserDashboardConnectedAppsPage:React.FC = () => {

    return (
        <Container className={'user-dashboard-page-container'}>
            <Row className={'user-dashboard-page-container__content'}>

                <UserDashboardPageUserMenu />

                <UserDashboardPageContent
                    headingText={'Connected Services'}
                    descriptionText={'Manage your connected apps and permissions'}
                >

                    <UserDashboardConnectedAppsSummarySection />

                    <UserDashboardPageContentSection
                        sectionName={'user-email-provider'}
                        sectionHeaderText={'Email Providers'}
                    >

                        <Col xs={12} className={'user-dashboard-service-provider-element'}>
                            <Row className={'user-dashboard-service-provider-element__content'}>
                                <Col xs={2} lg={1} className={'user-dashboard-service-provider-element__service-provider-icon'}>
                                    <SvgIconComponent iconSource={GmailLogo} />
                                </Col>
                                <Col xs={10} lg={7} className={'user-dashboard-service-provider-element__service-provider-information'}>
                                    <Row className={'user-dashboard-service-provider-element__service-provider-information__content'}>
                                        <Col xs={12} className={'user-dashboard-service-provider-element__service-provider-information__service-provider-name'}>
                                            <span>Gmail</span>
                                        </Col>
                                        <Col xs={12} className={'user-dashboard-service-provider-element__service-provider-information__service-provider-description'}>
                                            <span>sarah.johnson@gmail.com</span>
                                        </Col>
                                        <Col xs={12} className={'user-dashboard-service-provider-element__service-provider-information__service-provider-additional-info'}>
                                            <BadgeElementComponent
                                                badgeType={'success'} badgeSize={'md'}
                                                badgeText={'Connected'}
                                            />
                                            <span className={'additional-information'}>Last sync: 2 hours ago</span>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col xs={12} lg={4} className={'user-dashboard-service-provider-element__service-provider-options'}>
                                    <ButtonComponent
                                        text={'Settings'}
                                        type={'flat'} iconLeft={IconSettingsS} bordered={true}
                                        buttonDisabled={true}
                                    />
                                    <ButtonComponent
                                        text={'Disconnect'}
                                        type={'flat'} iconLeft={IconDisconnectS}
                                        buttonDisabled={true}
                                    />
                                </Col>
                            </Row>
                        </Col>

                        <Col xs={12} className={'user-dashboard-service-provider-element'}>
                            <Row className={'user-dashboard-service-provider-element__content'}>
                                <Col xs={2} lg={1} className={'user-dashboard-service-provider-element__service-provider-icon'}>
                                    <SvgIconComponent iconSource={OutlookLogo} />
                                </Col>
                                <Col xs={10} lg={7} className={'user-dashboard-service-provider-element__service-provider-information'}>
                                    <Row className={'user-dashboard-service-provider-element__service-provider-information__content'}>
                                        <Col xs={12} className={'user-dashboard-service-provider-element__service-provider-information__service-provider-name'}>
                                            <span>Outlook</span>
                                        </Col>
                                        <Col xs={12} className={'user-dashboard-service-provider-element__service-provider-information__service-provider-description'}>
                                            <span>sarah.johnson@outlook.com</span>
                                        </Col>
                                        <Col xs={12}
                                             className={'user-dashboard-service-provider-element__service-provider-information__service-provider-additional-info'}>
                                            <BadgeElementComponent
                                                badgeType={'warning'} badgeSize={'md'}
                                                badgeText={'Needs Reauth'} badgeIcon={false}
                                            />
                                            <span className={'additional-information'}>Token Expired</span>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col xs={12} lg={4} className={'user-dashboard-service-provider-element__service-provider-options'}>
                                    <ButtonComponent
                                        text={'Reconnect'}
                                        buttonDisabled={true}
                                    />
                                    <ButtonComponent
                                        text={'Remove'}
                                        type={'flat'} iconLeft={IconRemoveS}
                                        buttonDisabled={true}
                                    />
                                </Col>
                            </Row>
                        </Col>

                    </UserDashboardPageContentSection>

                    <UserDashboardPageContentSection
                        sectionName={'user-financial-services'}
                        sectionHeaderText={'Financial Services'}
                    >

                        <Col xs={12} className={'user-dashboard-service-provider-element'}>
                            <Row className={'user-dashboard-service-provider-element__content'}>
                                <Col xs={2} lg={1} className={'user-dashboard-service-provider-element__service-provider-icon'}>
                                    <SvgIconComponent iconSource={PaypallLogo} />
                                </Col>
                                <Col xs={10} lg={7} className={'user-dashboard-service-provider-element__service-provider-information'}>
                                    <Row className={'user-dashboard-service-provider-element__service-provider-information__content'}>
                                        <Col xs={12} className={'user-dashboard-service-provider-element__service-provider-information__service-provider-name'}>
                                            <span>PayPal</span>
                                        </Col>
                                        <Col xs={12} className={'user-dashboard-service-provider-element__service-provider-information__service-provider-description'}>
                                            <span>Payment processing</span>
                                        </Col>
                                        <Col xs={12}
                                             className={'user-dashboard-service-provider-element__service-provider-information__service-provider-additional-info'}>
                                            <BadgeElementComponent
                                                badgeType={'success'} badgeSize={'md'}
                                                badgeText={'Active'}
                                            />
                                            <span className={'additional-information'}>Connected 3 months ago</span>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col xs={12} lg={4} className={'user-dashboard-service-provider-element__service-provider-options'}>
                                    <ButtonComponent
                                        text={'Manage'}
                                        type={'flat'} iconLeft={IconSettingsS} bordered={true}
                                        buttonDisabled={true}
                                    />
                                    <ButtonComponent
                                        text={'Disconnect'}
                                        type={'flat'} iconLeft={IconDisconnectS}
                                        buttonDisabled={true}
                                    />
                                </Col>
                            </Row>
                        </Col>

                        <Col xs={12} className={'user-dashboard-service-provider-element'}>
                            <Row className={'user-dashboard-service-provider-element__content'}>
                                <Col xs={2} lg={1} className={'user-dashboard-service-provider-element__service-provider-icon'}>
                                    <SvgIconComponent iconSource={ButtonBank} />
                                </Col>
                                <Col xs={10} lg={7} className={'user-dashboard-service-provider-element__service-provider-information'}>
                                    <Row className={'user-dashboard-service-provider-element__service-provider-information__content'}>
                                        <Col xs={12} className={'user-dashboard-service-provider-element__service-provider-information__service-provider-name'}>
                                            <span>Chase Bank</span>
                                        </Col>
                                        <Col xs={12} className={'user-dashboard-service-provider-element__service-provider-information__service-provider-description'}>
                                            <span>Account ending in ****4567</span>
                                        </Col>
                                        <Col xs={12}
                                             className={'user-dashboard-service-provider-element__service-provider-information__service-provider-additional-info'}>
                                            <BadgeElementComponent
                                                badgeType={'success'} badgeSize={'md'}
                                                badgeText={'Connected'}
                                            />
                                            <span className={'additional-information'}>Last verified: 1 week ago</span>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col xs={12} lg={4} className={'user-dashboard-service-provider-element__service-provider-options'}>
                                    <ButtonComponent
                                        text={'Update'}
                                        type={'flat'} iconLeft={IconClockS} bordered={true}
                                        buttonDisabled={true}
                                    />
                                    <ButtonComponent
                                        text={'Remove'}
                                        type={'flat'} iconLeft={IconRemoveS}
                                        buttonDisabled={true}
                                    />
                                </Col>
                            </Row>
                        </Col>

                    </UserDashboardPageContentSection>

                    <UserDashboardPageContentSection
                        sectionName={'user-travel-services'}
                        sectionHeaderText={'Travel & Booking Services'}
                    >

                        <Col xs={12} className={'user-dashboard-service-provider-element'}>
                            <Row className={'user-dashboard-service-provider-element__content'}>
                                <Col xs={2} lg={1} className={'user-dashboard-service-provider-element__service-provider-icon'}>

                                </Col>
                                <Col xs={10} lg={6} className={'user-dashboard-service-provider-element__service-provider-information'}>
                                    <Row className={'user-dashboard-service-provider-element__service-provider-information__content'}>
                                        <Col xs={12} className={'user-dashboard-service-provider-element__service-provider-information__service-provider-name'}>
                                            <span>Expedia</span>
                                        </Col>
                                        <Col xs={12} className={'user-dashboard-service-provider-element__service-provider-information__service-provider-description'}>
                                            <span>Flight and hotel bookings</span>
                                        </Col>
                                        <Col xs={12}
                                             className={'user-dashboard-service-provider-element__service-provider-information__service-provider-additional-info'}>
                                            <BadgeElementComponent
                                                badgeType={'success'} badgeSize={'md'}
                                                badgeText={'Active'}
                                            />
                                            <span className={'additional-information'}>2 bookings monitored</span>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col xs={12} lg={5} className={'user-dashboard-service-provider-element__service-provider-options'}>
                                    <ButtonComponent
                                        text={'View data'}
                                        type={'flat'} iconLeft={IconNotesS} bordered={true}
                                        buttonDisabled={true}
                                    />
                                    <ButtonComponent
                                        text={'Disconnect'}
                                        type={'flat'} iconLeft={IconDisconnectS}
                                        buttonDisabled={true}
                                    />
                                </Col>
                            </Row>
                        </Col>

                        <Col xs={12} className={'user-dashboard-service-provider-element'}>
                            <Row className={'user-dashboard-service-provider-element__content'}>
                                <Col xs={2} lg={1} className={'user-dashboard-service-provider-element__service-provider-icon'}>

                                </Col>
                                <Col xs={10} lg={7} className={'user-dashboard-service-provider-element__service-provider-information'}>
                                    <Row className={'user-dashboard-service-provider-element__service-provider-information__content'}>
                                        <Col xs={12} className={'user-dashboard-service-provider-element__service-provider-information__service-provider-name'}>
                                            <span>Booking.com</span>
                                        </Col>
                                        <Col xs={12} className={'user-dashboard-service-provider-element__service-provider-information__service-provider-description'}>
                                            <span>Hotel reservations</span>
                                        </Col>
                                        <Col xs={12}
                                             className={'user-dashboard-service-provider-element__service-provider-information__service-provider-additional-info'}>
                                            <BadgeElementComponent
                                                badgeType={'paused'} badgeSize={'md'}
                                                badgeText={'Paused'}
                                            />
                                            <span className={'additional-information'}>Monitoring disabled</span>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col xs={12} lg={4} className={'user-dashboard-service-provider-element__service-provider-options'}>
                                    <ButtonComponent
                                        text={'Resume'}
                                        iconLeft={IconFilePresentS}
                                        buttonDisabled={true}
                                    />
                                    <ButtonComponent
                                        text={'Remove'}
                                        type={'flat'} iconLeft={IconRemoveS}
                                        buttonDisabled={true}
                                    />
                                </Col>
                            </Row>
                        </Col>

                    </UserDashboardPageContentSection>

                    <UserDashboardPageContentSection
                        sectionName={'user-permissions-and-security'}
                        sectionHeaderText={'Permissions & Security'}
                    >

                        <DashboardStateCardElementComponent
                            cardType={'info'}
                            cardTitle={'Read-Only Access'}
                            cardDescription={'All connected services have read-only access to your data. We never modify or delete your information.'}
                        />

                        <Col xs={6} className={'user-dashboard-service-provider-element'}>
                            <Row className={'user-dashboard-service-provider-element__content'}>
                                <Col xs={12} className={'user-dashboard-service-provider-element__service-provider-information'}>
                                    <Row className={'user-dashboard-service-provider-element__service-provider-information__content'}>
                                        <Col xs={12} className={'user-dashboard-service-provider-element__service-provider-information__service-provider-name'}>
                                            <span>Data Encryption</span>
                                        </Col>
                                        <Col xs={12} className={'user-dashboard-service-provider-element__service-provider-information__service-provider-description'}>
                                            <span>All data is encrypted in transit and at rest using AES-256 encryption.</span>
                                        </Col>
                                        <Col xs={12}
                                             className={'user-dashboard-service-provider-element__service-provider-information__service-provider-additional-info'}>
                                            <BadgeElementComponent
                                                badgeType={'success'} badgeSize={'md'}
                                                badgeText={'Secured'}
                                            />
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Col>

                        <Col xs={6} className={'user-dashboard-service-provider-element'}>
                            <Row className={'user-dashboard-service-provider-element__content'}>
                                <Col xs={12} className={'user-dashboard-service-provider-element__app-information'}>
                                    <Row className={'user-dashboard-service-provider-element__app-information__content'}>
                                        <Col xs={12} className={'user-dashboard-service-provider-element__service-provider-information__service-provider-name'}>
                                            <span>Access Monitoring</span>
                                        </Col>
                                        <Col xs={12} className={'user-dashboard-service-provider-element__service-provider-information__service-provider-description'}>
                                            <span>We monitor all access to your connected accounts and alert you of any suspicious activity.</span>
                                        </Col>
                                        <Col xs={12}
                                             className={'user-dashboard-service-provider-element__service-provider-information__service-provider-additional-info'}>
                                            <BadgeElementComponent
                                                badgeType={'success'} badgeSize={'md'}
                                                badgeText={'Active'}
                                            />
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Col>

                        <DividerElementComponent />

                        <Col xs={12} className={'permissions-and-security-log'}>
                            <Row className={'permissions-and-security-log__content'}>
                                <Col xs={6} className={'permissions-and-security-log__security-log'}>
                                    <span className={'link-button-element'}>View Security Log</span>
                                </Col>
                                <Col xs={6} className={'permissions-and-security-log__revoke-access'}>
                                    <ButtonComponent
                                        text={'Revoke All Access'}
                                        type={'flat'} bordered={true}
                                        buttonDisabled={true}
                                    />
                                </Col>
                            </Row>
                        </Col>

                    </UserDashboardPageContentSection>

                </UserDashboardPageContent>

            </Row>
        </Container>
    );

};


export default UserDashboardConnectedAppsPage;
